module.exports = __webpack_public_path__ + "img/TuckerDavis.ebbe1f33.png";